import { useState, useEffect, useCallback } from 'react';
function getStorage(key, initialValue) {
    if (!(window === null || window === void 0 ? void 0 : window.localStorage)) {
        return initialValue;
    }
    try {
        const stringValue = window.localStorage.getItem(key);
        return stringValue ? JSON.parse(stringValue) : initialValue;
    }
    catch (_a) {
        return initialValue;
    }
}
export function useLocalStorage(key, initialValue) {
    const [value, setValue] = useState(() => getStorage(key, initialValue));
    const setStorageValue = useCallback((value) => {
        var _a;
        // eslint-disable-next-line no-unused-expressions
        (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(key, JSON.stringify(value));
        setValue(value);
    }, [key]);
    useEffect(() => {
        if (!(window === null || window === void 0 ? void 0 : window.localStorage)) {
            return;
        }
        const notify = (e) => {
            if (e.storageArea === localStorage && e.key === key) {
                try {
                    setValue(e.newValue ? JSON.parse(e.newValue) : initialValue);
                }
                catch (_a) {
                    setValue(initialValue);
                }
            }
        };
        window.addEventListener('storage', notify);
        return () => {
            window.removeEventListener('storage', notify);
        };
    }, [initialValue, key]);
    return [value, setStorageValue];
}
//# sourceMappingURL=index.js.map